/**
 * Update the <title> of the document
 */
export function setTitle(title: string) {
  if (document.title !== title) {
    document.title = title;
  }
}

/**
 * Apply CSS variables globally
 **/
export function setCssVars(vars: Record<string, string>) {
  const root = document.documentElement;
  for (const [key, value] of Object.entries(vars)) {
    if (root.style.getPropertyValue(key) !== value) {
      root.style.setProperty(key, value);
    }
  }
}

/**
 * Update the favicon
 **/
export function setFavicon(href: string) {
  // remove any existing icons to avoid duplicates
  document.querySelectorAll("link[rel*='icon']").forEach((el) => el.remove());

  const link = document.createElement("link");
  link.rel = "icon";
  link.href = href;
  document.head.appendChild(link);
}
